import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import UserList from './list/UserList';
import AdminAddOffPlatformTalent from './AdminAddOffPlatformTalent';
import './AdminUsersIndex.scss';
import UserDashboard from "./list/UserDashboard";
import UserRiskboard from "./list/UsersRiskIndex";


function TabPanel(props) {
  const {
    children, value, index, ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div p={3}>
          <Typography component="div">{children}</Typography>
        </div>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    // backgroundColor: theme.palette.background.paper,
  },
  tabBar: {
    backgroundColor: 'transparent',
    color: 'white',
    boxShadow: 'none',
  },
}));

export default function SimpleTabs(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const { data } = props.admin.tip;
  const userCount = (data&&data.user)?(data.user.warnCount+data.user.disputeCount+data.user.reviewCount):0

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={`admin-users-tab-container ${classes.root}`}>
      <AppBar position="static" className={classes.tabBar}>
        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
          <Tab label="Users List" {...a11yProps(0)} />
          <Tab label="Add Off Platform Talent" {...a11yProps(1)} />
          <Tab label="User Dashboard" {...a11yProps(2)} />
          <Tab label={`Risk Users${userCount?'('+userCount+')':''}`} {...a11yProps(3)} />

        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <UserList {...props} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <AdminAddOffPlatformTalent {...props} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <UserDashboard {...props} />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <UserRiskboard {...props} />
      </TabPanel>

    </div>
  );
}
